import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import Icon from './Icon';
import { TABS, NEW_SALE_PATH } from './navConfig';

const tabClass = 'flex-1 flex flex-col items-center justify-center gap-0.5 text-[11px] font-medium';

const BottomNav = ({ onMore }) => {
  const navigate = useNavigate();
  return (
    <nav aria-label="Main" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-slate-200 pb-[env(safe-area-inset-bottom)]">
      <ul className="grid grid-cols-5 h-16">
        {TABS.map((t) => (
          <li key={t.to || t.key} className="flex">
            {t.key === 'new' ? (
              <button type="button" aria-label="New sale" onClick={() => navigate(NEW_SALE_PATH)}
                className="m-auto -mt-5 w-14 h-14 rounded-full bg-blue-600 text-white shadow-lg shadow-blue-600/30 flex items-center justify-center active:scale-95 transition">
                <Icon name="plus" className="w-7 h-7" />
              </button>
            ) : t.key === 'more' ? (
              <button type="button" aria-label="More" onClick={onMore} className={`${tabClass} text-slate-500`}>
                <Icon name={t.icon} /><span>{t.label}</span>
              </button>
            ) : (
              <NavLink to={t.to} aria-label={t.label}
                className={({ isActive }) => `${tabClass} ${isActive ? 'text-blue-600' : 'text-slate-500'}`}>
                <Icon name={t.icon} /><span>{t.label}</span>
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default BottomNav;
